// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","logo-spin":"Spinner_logo-spin__lvPJb"};